import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ChatbotService } from './core/services/chatbot.service';
import { CookieService } from './core/services/cookie.service';
import { ErrorService } from './core/services/error.service';
import { CookieBannerDialogComponent } from './shared/components/cookie-banner-dialog/cookie-banner-dialog.component';
import { AuthService } from './core/services/auth.service';
import {
  checkBrowserLanguage,
  defaultLanguageKey,
  languageKeys,
} from './shared/models/language.dto';

@Component({
  selector: 'vee-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'amuvee-website';
  @ViewChild(CookieBannerDialogComponent)
  cookieDialog!: CookieBannerDialogComponent;

  constructor(
    public translate: TranslateService,
    private route: ActivatedRoute,
    public cookieService: CookieService,
    public errorService: ErrorService,
    private authService: AuthService,
    private chatbotService: ChatbotService,
  ) {
    translate.addLangs([...languageKeys]);
    translate.setDefaultLang(defaultLanguageKey);
    translate.use(checkBrowserLanguage(translate.getBrowserLang()));
    this.route.queryParams.subscribe((params: any) => {
      if (params['lang'] && languageKeys.includes(params['lang'])) {
        translate.use(params['lang']);
      }
    });

    void this.authService.loadUser().catch(() => {
      /* loadUser resolves errors internally; guard against unexpected throws */
    });
  }

  ngOnInit(): void {
    // Load chatbot if data protection consent is already given
    this.loadChatbotIfConsentGiven();

    // Open cookie dialog if needed
    this.checkAndOpenCookieDialog();
  }

  private loadChatbotIfConsentGiven(): void {
    // Check if data protection consent is already given
    if (this.cookieService.rights?.data_protection) {
      this.chatbotService.loadChatbot();
    } else {
      // Show disabled chatbot if data protection is not accepted
      this.chatbotService.showDisabledChatbot();
    }
  }

  private checkAndOpenCookieDialog(): void {
    // Open dialog if cookie banner should be shown
    if (
      this.cookieService.showSimpleBanner ||
      this.cookieService.changeOfRigthsNeeded
    ) {
      setTimeout(() => {
        this.cookieDialog?.openDialog();
      }, 100); // Small delay to ensure component is initialized
    }
  }
}
